import { ArticleType } from '@nemuru-eng/js-api-client';
import { z } from 'zod';

import { MinimalFormItemSchema } from '@/components/modules/Application/components/Cart/DefaultCart/components/shared/schemas/MinimalFormItemSchema';
import { GetTextIdTranslationType } from '@/components/shared/hooks/useTranslation';

export const ProductFormItemSchema = (t: GetTextIdTranslationType) =>
  MinimalFormItemSchema(t).merge(
    z.object({
      type: z.literal(ArticleType.ONLINE_PRODUCT),
    }),
  );
